import { render, staticRenderFns } from "./UpdateIdle.vue?vue&type=template&id=5fc447af&"
import script from "./UpdateIdle.vue?vue&type=script&lang=js&"
export * from "./UpdateIdle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports